import {
  Bank,
  Books,
  CalendarBlank,
  FunnelSimple,
  IdentificationCard,
  Power,
  SquaresFour,
  Student,
  Tag,
  UsersThree,
} from 'phosphor-react';
import { ElementType } from 'react';

const iconByField: Record<string, ElementType> = {
  group_id: UsersThree,
  institution_id: Bank,
  institutions: Bank,
  secretary_id: IdentificationCard,
  secretaries: IdentificationCard,
  school_class_id: Books,
  module_id: Books,
  modules: Books,
  team_id: Student,
  teams: Student,
  category_id: Tag,
  categories: Tag,
  type: SquaresFour,
  user_type: UsersThree,
  status: Power,
  date: CalendarBlank,
  start_date: CalendarBlank,
  end_date: CalendarBlank,
};

export const getFacetIcon = (field: string): ElementType => iconByField[field] ?? FunnelSimple;

const labelPrefixes = [
  'selecionar ',
  'filtrar por ',
  'selecione ',
  'todos os ',
  'todas as ',
  'buscar por ',
];

export const deriveFacetLabel = (placeholder?: string, field?: string): string => {
  const source = placeholder ?? field ?? 'Filtro';
  const lower = source.toLowerCase();
  const prefix = labelPrefixes.find((entry) => lower.startsWith(entry));
  const cleaned = prefix ? source.slice(prefix.length) : source;
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
};

export const deriveAnyLabel = (label: string): string => `Qualquer ${label.toLowerCase()}`;
